<template>
  <AuthenticationButton :loading="loading" @click="$emit('click')">
    <img :src="microsoftLogo" />
    <span>{{ $t('Login.signInWithMicrosoft') }}</span>
  </AuthenticationButton>
</template>

<script setup lang="ts">
import microsoftLogo from '@/assets/media/img/microsoft.svg';

import AuthenticationButton from './AuthenticationButton.vue';

defineEmits<{
  (e: 'click'): void;
}>();

defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>
